import { useGlobalConfigContext } from '../../../global-config'
import { TENANTS_TO_SHOW_RX_NOT_IN_CATALOG_PRODUCTS } from '../../../tenant'

/**
 * Returns Algolia filters for header search.
 *
 * @returns {string}
 */
export const useHeaderSearchAlgoliaFilters = (): string => {
  const { tenant } = useGlobalConfigContext()

  // prescription medicines should be searchable for all stockStatusReasons other than not_in_sale or freebie(which shouldn't be the case anyway)
  const prescriptionMedicineFilter =
    'prescriptionMedicine:true AND NOT stockStatusReason:product.stockStatus.gratis AND NOT stockStatusReason:product.stockStatus.av'

  const defaultFilter = `(stockStatusReason:product.stockStatus.available OR stockStatusReason:product.stockStatus.nl)`

  return TENANTS_TO_SHOW_RX_NOT_IN_CATALOG_PRODUCTS.includes(tenant)
    ? `${defaultFilter} OR ${prescriptionMedicineFilter}`
    : defaultFilter
}
